import { PeriodSeqComboBoxComponent } from './period-seq-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';

/**
 * 受注コード期間マスタコンボボックスモデル
 *
 * @export PeriodSeqComboBoxModel
 * @class PeriodSeqComboBoxModel
 */
export class PeriodSeqComboBoxModel {

  // 受注コード期間マスタリスト
  public codeList: Array<any>;
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setCodeValue: string;
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // コンボボックスインスタンス
  public component: PeriodSeqComboBoxComponent;
  // コード一覧全件
  public codeAllList: Array<any>;
  // 選択・１物Ｎ価詳細区分
  public ibnkssaKb: string = <string>'';

  /**
   * リスト更新する
   *
   * @param {*} serverData サーバ取得データ
   * @returns {void}
   * @memberof PeriodSeqComboBoxModel
   */
  public updateCodeList(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankObject());
      index = 1;
    }

    this.codeAllList = tempDataList;

    this._updateList(this.ibnkssaKb);

    this.completeUpdateFlg = true;
    this.component.updateSelectedCodeValue();
  }

  /**
   * 選択・１物Ｎ価詳細区分を反映した一覧作成
   *
   * @private
   * @param {string} ibnkssaKb １物Ｎ価詳細区分
   * @memberof PeriodSeqComboBoxModel
   */
  private _updateList(ibnkssaKb: string): void {
    if (PlessViewUtilsSub.isEmpty(ibnkssaKb)) {                                 // 選択なしの場合
      this.codeList = this.codeAllList;
    this.component.selectedPeriodSeq = '';
    this.component.selectedPeriodTitle = '';
    this.component.selectedReceiptSOrderCode = '';
    this.component.selectedReceiptEOrderCode = '';
    this.component.selectedMediumType = '';
    this.component.selectedIndex = -1;
    } else {                                                                    // 選択ありの場合
      const tempDataList: Array<any> = new Array<any>();
      let str = String('');

      // コード一覧全件リスト件数分の一覧を作成
      // コード一覧全件リスト件数分ループ
      for (let cnt = Number(0); cnt < this.codeAllList.length; cnt++) {
        str = this.codeAllList[cnt].IbnkssaKb;

        // 選択・１物Ｎ価詳細区分との比較
        // 同一１物Ｎ価詳細区分の場合 ブランク行も含める
        if (str === ibnkssaKb || PlessViewUtilsSub.isEmpty(str)) {
          tempDataList.push(this.codeAllList[cnt]);
        }
      }
      this.codeList = tempDataList;
    }
  }

  /**
	 * 一覧を更新する。
	 * 指定の１物Ｎ価詳細区分が掲載対象の媒体に絞込み表示する
	 *
	 * @param ibnkssaKb:１物Ｎ価詳細区分
	 */
  public updateList(ibnkssaKb: string): void {
    this._updateList(ibnkssaKb);
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @returns {object}
   * @memberof PeriodSeqComboBoxModel
   */
  private getBlankObject(): object {
    const ob: any = {};
    ob.PeriodSeq = '';
    ob.PeriodTitle = '';
    ob.ReceiptSOrderCode = '';
    ob.ReceiptEOrderCode = '';
    ob.MediumType = '';
    ob.ReceiptSEOrderCode = '';
    ob.IbnkssaKb = '';

    return ob;
  }

}
